import * as yup from 'yup';
import { IValidationNumberPortability } from './portabilityNumber.models';

export const portabilityNumberSchema = (validationMessage?: IValidationNumberPortability) =>
  yup.object({
    phoneNumber: yup
      .string()
      .required(validationMessage?.requiredField || 'Campo obbligatorio')
      .matches(
        /^0[1-9]([0-9]{5,8}$)/,
        validationMessage?.validNumber || 'Inserire un numero valido'
      ),
  });
